import {Configuration} from 'sparkloyalty-frontend/configuration';

export let config: Configuration;

export function initConfig(environment: any) {
    config = new Configuration(environment, '');
}
